<template>
  <v-dialog
    v-model="active"
    persistent
    transition="dialog-bottom-transition"
    style="z-index: 2000"
    max-width="400"
    :retain-focus="false"
  >
    <v-form ref="form" v-model="valid">
      <v-card
        class="text-center"
        :class="
          getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
        "
        :style="
          getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'
        "
      >
        <v-card-title
          :style="
            getTheme() == 'dark'
              ? 'background-color: #505050'
              : 'background-color: white; border-bottom: 1px solid lightgray'
          "
          :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
          class="title font-weight-regular"
        >
          <v-icon
            :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
            class="mr-3"
            medium
            >mdi-resize</v-icon
          >
          {{ $t("dialogCustomSizeTitle") }}
        </v-card-title>
        <v-card-text class="pt-3 pb-3">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs-12 class="pb-3">
                {{ $t("lmMax") }}
                {{
                  $store.state.storePhotoGiftOrderDesign.maxCustomSizeWidth
                }}x{{
                  $store.state.storePhotoGiftOrderDesign.maxCustomSizeHeight
                }}
                {{ showUnit }}
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  dense
                  ref="widthField"
                  v-model="
                    $store.state.storePhotoGiftOrderDesign.customSizeWidth
                  "
                  type="number"
                  :label="$t('lmWidthCustomSize')"
                  :rules="[validateRequired(), validateIsNumber()]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  dense
                  v-model="
                    $store.state.storePhotoGiftOrderDesign.customSizeHeight
                  "
                  type="number"
                  :label="$t('lmHeightCustomSize')"
                  :rules="[validateRequired(), validateIsNumber()]"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions
          :class="getTheme() == 'dark' ? '#505050--text' : '#505050--text'"
          :style="
            getTheme() == 'dark'
              ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
              : 'background-color: white; border-top: 1px solid lightgray;'
          "
        >
          <v-spacer></v-spacer>
          <v-btn color="primary" text class="mx-0" @click="clickApply">{{
            $t("lmBtnApply")
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-custom-size",
  props: {
    active: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      valid: false,
    };
  },
  computed: {
    showUnit() {
      return "cm";
    },
  },
  methods: {
    clickApply: function () {
      if (this.$refs.form.validate()) {
        // preverimo, če vpisana velikost mogoča glede na max velikost
        if (
          (Number(
            this.$store.state.storePhotoGiftOrderDesign.customSizeWidth
          ) >=
            Number(
              this.$store.state.storePhotoGiftOrderDesign.customSizeHeight
            ) &&
            this.$store.state.storePhotoGiftOrderDesign.maxCustomSizeWidth >=
              Number(
                this.$store.state.storePhotoGiftOrderDesign.customSizeWidth
              ) &&
            this.$store.state.storePhotoGiftOrderDesign.maxCustomSizeHeight >=
              Number(
                this.$store.state.storePhotoGiftOrderDesign.customSizeHeight
              )) ||
          (Number(this.$store.state.storePhotoGiftOrderDesign.customSizeWidth) <
            Number(
              this.$store.state.storePhotoGiftOrderDesign.customSizeHeight
            ) &&
            this.$store.state.storePhotoGiftOrderDesign.maxCustomSizeWidth >=
              Number(
                this.$store.state.storePhotoGiftOrderDesign.customSizeHeight
              ) &&
            this.$store.state.storePhotoGiftOrderDesign.maxCustomSizeHeight >=
              Number(
                this.$store.state.storePhotoGiftOrderDesign.customSizeWidth
              ))
        ) {
          this.$emit("clickApply");
        } else
          this.$store.commit({
            type: "showSnackbar",
            color: "error",
            message: this.$t("lmFrmErrorMaxCustomSizeField"),
          });
      }
    },
  },
  created() {
    // izračunamo dimenzije največje možne custom slike
    let w = 0,
      h = 0;
    this.$store.state.storeImageSize.imageSize.forEach((x) => {
      if (Number(x.sizeX) > w) {
        w = Number(x.sizeX);
        h = Number(x.sizeY);
      }
    });
    this.$store.state.storePhotoGiftOrderDesign.maxCustomSizeWidth = Math.trunc(
      (w * 25.4) / 300 / 10
    );
    this.$store.state.storePhotoGiftOrderDesign.maxCustomSizeHeight = Math.trunc(
      (h * 25.4) / 300 / 10
    );
    /*console.log(
      "maxWH: ",
      Math.trunc(
        this.$store.state.storePhotoGiftOrderDesign.maxCustomSizeWidth
      ),
      Math.trunc(
        this.$store.state.storePhotoGiftOrderDesign.maxCustomSizeHeight
      )
    );*/
  },
  mounted() {
    setTimeout(() => this.$refs.widthField.$refs.input.focus(), 100);
  },
};
</script>

<style scoped>
</style>